"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getAppFromLinkPathname;

var _apps = _interopRequireDefault(require("./apps"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var directoryApp = _apps["default"].find(function (app) {
  return app.key === 'directory';
});

if (!directoryApp) throw new Error('could not find directory key in apps in skipper');

function getAppFromLinkPathname(pathname) {
  var base = pathname.toLowerCase().split('/')[1].trim();

  var app = _apps["default"].find(function (app) {
    return app.to.split('/')[1].toLowerCase() === base;
  });

  if (app) {
    return app;
  }

  return directoryApp;
}